import React, { useEffect, useState } from 'react'
import { compose, graphql } from 'react-apollo'
import { Constants, ListPanel } from '@sukiai/components'
import { GetUnfinishedCompositions } from '@sukiai/gql/app'
import { SET_AGENT_POSITION, SET_AGENT_SIZE } from '../apollo/actions'
import { withRouter } from 'react-router'
import {
  LO_STO,
  ROUTES,
  FETCH_POLICY
} from '../lib'
import { RESPONSIVE } from '../lib/constants'
import loSto from '../config/loSto'
import { useMediaQuery } from 'react-responsive'
import { getListPanelMarginProps } from '../lib/helpers'

const { AGENT, LISTS, DIMENSIONS } = Constants
const { LIST_CELL_ONE } = DIMENSIONS
const EMPTY_LIST = LIST_CELL_ONE * 3 + 2

const UnfinishedNotesContainer = (props) => {
  const [calcheight, setCalcHeight] = useState(EMPTY_LIST)

  const isSmallWindow = useMediaQuery({
    query: `(max-width: ${RESPONSIVE.SMALL_LIST_PANEL_WIDTH})`
  })

  const isCrampedWindow = useMediaQuery({
    query: `(max-width: ${RESPONSIVE.CRAMPED_LIST_PANEL_WIDTH})`
  })

  useEffect(() => {
    props.setAgentPosition(AGENT.POSITION.MIDDLE_LEFT)
    props.setAgentSize(AGENT.SIZE.LARGE)
  }, [])

  useEffect(() => {
    if (props.unfinishedLoading || props.unfinishedCount === 0) {
      setCalcHeight(EMPTY_LIST)
    } else if (props.unfinishedCount && props.unfinishedCount > 3) {
      setCalcHeight(
        props.unfinishedCount * LIST_CELL_ONE + (props.unfinishedCount - 1)
      )
    } else {
      setCalcHeight(EMPTY_LIST)
    }
  })

  const onNoteClick = (noteId, patientId) => {
    const { history } = props
    loSto.set(LO_STO.CURRENT_COMP_ID, noteId)
    loSto.remove(LO_STO.CURRENT_NOTE_ID)
    loSto.set(LO_STO.CURRENT_PATIENT_ID, patientId)

    history.push(`${ROUTES.NOTE}/${noteId}`)
  }

  const marginProps = getListPanelMarginProps()

  return (
    <div style={{ width: '100vw' }}>
      <ListPanel
        type={LISTS.UNFINISHED_NOTES}
        title='Unfinished Notes'
        loading={props.unfinishedLoading}
        notes={props.unfinishedData}
        handleClick={onNoteClick}
        count={props.unfinishedCount}
        calcheight={calcheight}
        isSmallWindow={isSmallWindow}
        isCrampedWindow={isCrampedWindow}
        {...marginProps}
      />
    </div>
  )
}

const noteSort = (noteResults) => {
  noteResults.sort((a, b) => {
    let timestampA = a?.metadata?.appointment?.startsAt || a?.createdAt
    let timestampB = b?.metadata?.appointment?.startsAt || b?.createdAt

    timestampA = new Date(timestampA)
    timestampB = new Date(timestampB)

    return timestampB > timestampA ? 1 : timestampB < timestampA ? -1 : 0
  })
  return noteResults
}

const mapUnfinishedToProps = ({ data }) => ({
  unfinishedError: data.error,
  unfinishedLoading: data.loading,
  unfinishedCount: data.incompleteCompositions
    ? data.incompleteCompositions.count
    : 0,
  unfinishedData: data.incompleteCompositions
    ? noteSort(data?.incompleteCompositions?.results?.slice())
    : []
})

export default compose(
  graphql(SET_AGENT_POSITION, {
    props: ({ mutate }) => ({
      setAgentPosition: (agentPosition) =>
        mutate({
          variables: {
            agentPosition
          }
        })
    })
  }),
  graphql(SET_AGENT_SIZE, {
    props: ({ mutate }) => ({
      setAgentSize: (agentSize) =>
        mutate({
          variables: {
            agentSize
          }
        })
    })
  }),
  graphql(GetUnfinishedCompositions, {
    options: () => ({
      variables: {
        userId: loSto.get(LO_STO.USER_ID)
      },
      fetchPolicy: FETCH_POLICY.NETWORK_ONLY
    }),
    props: mapUnfinishedToProps
  }),
  withRouter
)(UnfinishedNotesContainer)
